import 'isomorphic-fetch';
import { config } from 'config';

export const api = {
	facturacion: {
		async create(data) {
			const response = await fetch(config.URL_API + '/facturas/liquidacionFletero', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getPendientes(id) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/pendientes/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async estado(data) {
			const response = await fetch(config.URL_API + `/facturacion_fleteros/estado`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getLiquidados(id) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/liquidados/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/facturacion_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data) {
			const response = await fetch(config.URL_API + `/facturacion_fleteros/baja`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async update(data) {
			const response = await fetch(config.URL_API + '/facturacion_fleteros/modificar', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	recibo: {
		async getAllComp(id) {
			const response = await fetch(config.URL_API + '/facturas/coprobanteFletero/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getRecibo(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllLiq(id) {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async pdfComp(id, mimeType) {
			const res = await fetch(config.URL_API + '/facturas/pdfComprobanteFletero/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
		async pdfLiq(id, mimeType) {
			const res = await fetch(config.URL_API + '/liquidaciones_fleteros/pdfLiquidacion/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
		async pdfRecibo(id, mimeType) {
			const res = await fetch(config.URL_API + '/cobros_clientes/pdfRecibo/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: mimeType })
			return file;
		},
	},
	viajes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/facturas/viajesComprobante&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	tipodoc: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/documentos&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	localidades: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/localidades&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	choferes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/choferes_fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + `/choferes_fleteros/choferes/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	vales: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/conceptos_vales&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	acopiadores: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/acopiadores&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/acopiadores/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	fleteros: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async preparar(id) {
			const response = await fetch(config.URL_API + '/fleteros/prepararLiquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	fpago: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	camiones: {
		async getAll(id) {
			const response = await fetch(config.URL_API + `/camiones_fleteros/camiones/${id}`, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas_bancarias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_bancarias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	alicuotas: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/alicuotas&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	mercaderias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/mercaderias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
};
